async function removeAndSyncWarranties(reload = false) {
  await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      mulberryShop
        
        .removeDetachedWarranty(firstCart) // Remove Warranties First
        .then((newCart) => {
          mulberryShop.cart
            .syncQuantities(newCart) // Sync Quantities Second
            .then((content) => {
              if (reload) {
                window.location.reload()
              } else {
                const event = new Event('theme:request_cart_update')
                document.dispatchEvent(event)
              }
            })
        })
    })
  })
}

function stringifyProperties(cart) {
  return new Promise(async (resolve, reject) => {
    let temp
    for (i = 0; i < cart.items.length; i++) {
      item = cart.items[i]
      newProperties = {}
      for (const [key, value] of Object.entries(item.properties)) {
        temp = value
        if (typeof value != 'string') {
          newProperties[key] = JSON.stringify(value)
        } else {
          newProperties[key] = value
        }
      }
      if (Object.keys(newProperties).length > 0 && typeof temp != 'string') {
        try {
          let response = await jQuery.post('/cart/change.js', {
            line: i + 1,
            properties: newProperties
          })
        } catch (e) {
          console.log('mulberry error: ', e)
        }
      }
    }
    resolve('Mulberry Finished')
  })
}

function stringify() {
  fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      mulberryShop.removeDetachedWarranty(firstCart).then((newCart) => {
        mulberryShop.cart.syncQuantities(newCart).then((content) => {
          stringifyProperties(content).then((res) => {
            const event = new Event('theme:request_cart_update')
            document.dispatchEvent(event)
            setTimeout(() => {
              $(`dl[class="CartItem-properties"]`).text('')
              setCartInfoAndRender(true)
            }, 500)
          })
        })
      })
    })

  })
}

// // Hide Mulberry on PDP - Sep 16, 2024
// async function mulberryInit() {
//   let url = window.location.href;
//   let params = new URLSearchParams(new URL(url).search);
//   let variantIdFromUrl = params.get("variant");
//   if (variantIdFromUrl) {
//     mulberryShop.selectedVariantId = variantIdFromUrl;
//   }
//   let response = await mulberryShop.getProductData(mulberryShop.getProductUrl());
//   let product = response.product;
//   let selectedVariant = product.variants.find(
//     (i) => i.id == mulberryShop.selectedVariantId
//   );
//   const offers = await mulberry.core.getWarrantyOffer({
//     id: selectedVariant.id,
//     title: product.title,
//     price: selectedVariant.price,
//     detail: product
//   })
//   const { settings } = mulberry.core
//   let selectedOffer

//   if (offers.length > 0) {
//     $('.mulberry-inline-container').removeClass('shimmer')
//   } else {
//     $('.mulberry-inline-container').hide()
//   }

//   let selector = '.mulberry-inline-container'

//   let pdpInline = await mulberry.inline.init({
//     offers: offers,
//     settings: mulberry.core.settings,
//     selector: selector,
//     onWarrantyToggle: async (warranty) => {
//       mulberry.inline.isSelected = warranty.isSelected
//       if (warranty.isSelected) {
//         selectedOffer = warranty.offer
//       } else {
//         selectedOffer = null
//       }
//     }
//   })

//   let productDdata = $('.product-details').attr('data')

//   $(`.pdp-atc-${productDdata}`).submit(async function () {
//     if (offers.length === 0) {
//       return
//     }

//     if (selectedOffer) {
//       mulberry.inline.setLoading(true)
//       setTimeout(async () => {
//         const result = await mulberryShop.getWarrantyVariant(selectedOffer)
//         await mulberryShop.addWarrantyToCart(
//           result.shopify_variant_id,
//           product,
//           selectedOffer
//         )

//         stringify()
//         mulberry.inline.setLoading(false)
//         mulberry.inline.deselectOffer()
//         selectedOffer = null
//       }, 700)
//     } else {
//       setTimeout(() => {
//         setCartInfoAndRender()
//       }, 2000)
//     }
//   })
// }

document.addEventListener('mulberry-shopify:warranty-added', () => {
  //   removeAndSyncWarranties();
  // mulberryShop.cart.render()
})

document.addEventListener('mulberry-shopify:loaded', async () => {
  setupAjaxListeners()
  // Hide Mulberry on PDP - Sep 16, 2024
  // if (document.location.href.search('products/') !== -1) {
  //   if (typeof mulberryShop !== 'undefined') {
  //     mulberryInit()
  //   }
  //   setTimeout(() => {
  //     $(`dl[class="CartItem-properties"]`).text('')
  //   }, 500)
  // }
  if (document.location.href.search('cart') !== -1) {
    await mulberryShop.cart.init()
    mulberryShop.cart.render()
  }
  setCartInfoAndRender(true)
})

function setupAjaxListeners() {
  // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
  // Since we cant create globals we test for the XMLHttpRequest overwrite
  if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
    // We mock fetch() in order to determine if we should mock then() as well
    var mbFetch = fetch
    fetch = function () {
      var url = arguments[0]
      var body = ''
      if (arguments.length > 1 && typeof arguments[1].body !== 'undefined') {
        body = arguments[1].body
      }
      var promise = mbFetch.apply(this, arguments)
      if (url && url.indexOf && url.indexOf('cart/change') !== -1) {
        //If its a product being added to cart we add a function to track it
        promise = promise.then(function (response) {
          if (response.ok) {
            //trackAjaxAddToCart(body, response.clone().json());
          }
          return response
        })
      }
      return promise
    }
  }
  if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
    // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
    XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open
    XMLHttpRequest.prototype.open = function () {
      var url = arguments[1]
      if (url && url.indexOf && url.indexOf('cart/change') !== -1) {
        // debugger
        // We mock the instance's send method if the request is to the "add to the cart" url.
        this.mbSend = this.send
        this.send = function (value) {
          try {
            if (value) {
              var self = this // The xhttp request object

              var trackOnSuccess = function () {
                if (self.readyState === 4 && self.status === 200) {
                  removeAndSyncWarranties()
                }
              }

              if (typeof self.addEventListener !== 'undefined') {
                self.addEventListener('readystatechange', trackOnSuccess)
              } else {
                if (
                  typeof self.onreadystatechange !== 'undefined' &&
                  self.onreadystatechange !== null
                ) {
                  // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                  self.mbOnreadystatechange = self.onreadystatechange
                  self.onreadystatechange = function () {
                    self.mbOnreadystatechange()
                    trackOnSuccess()
                  }
                } else {
                  // If there is no onreadystatechange callback, we can safely set it.
                  self.onreadystatechange = trackOnSuccess
                }
              }
            }
          } catch (e) {
            console.log(e)
          }
          this.mbSend(value)
        }
      }
      this.mbOpen.apply(this, arguments)
    }
  }
}

function setCartInfo() {
  $('warranty-details').each(function (idx, item) {
    $(item).remove()
  })
  document.querySelectorAll('#js-cart-drawer .CartItem').forEach(function (item) {
    variantId = item.getAttribute('data-id')
    item.setAttribute('data-mulberry-variant-id', variantId)
    if (
      $(item).find(' .CartItem-title').text().indexOf('Mulberry Protection') !== -1
    ) {
      item.setAttribute('style', 'display: none;')
    } else {
      item.setAttribute('style', '')
    }
    var $newWarrantyDetails = $('<warranty-details/>').attr(
      'data-variant-id',
      variantId
    )
    var $newSpan = $('<span/>')
    $newSpan.css({ 'line-height': '1rem' })
    $newSpan.append($newWarrantyDetails)
    $(item).find('.CartItem-variantTitle').append($newSpan)
  })
}

async function setCartInfoAndRender(init = true) {
  setCartInfo()
  if (init) {
    await mulberryShop.cart.init()
  }
  await mulberryShop.cart.render()
  cartResp = await fetch('/cart.js')
  cart = await cartResp.json()
  durationMap = {}
  cart.items.forEach(function (item) {
    warranty = item?.properties?._warranty
    if (warranty) {
      durationMap[item.properties._variantId] = JSON.parse(
        item.properties._warranty
      ).duration_months
    }
  })

  $('warranty-details').each(function (idx, item) {
    variantId = $(item).attr('data-variant-id')
    duration = durationMap[variantId]
    shadowRoot = item.shadowRoot
    $(shadowRoot)
      .find('.duration')
      .text(duration / 12)
  })
  await mulberryShop.cart.render()
}

document.addEventListener('mulberry-shopify:warranty-added', () => {
  stringify()
  //removeAndSyncWarranties();
})

let lastURL = window.location.href;

setInterval(function() {
    if (lastURL !== window.location.href) {
      // // Hide Mulberry on PDP - Sep 16, 2024
      // if (document.querySelector('.mulberry-inline-container')) {
      //   document.querySelector('.mulberry-inline-container').innerHTML = '';
      // }
      setupAjaxListeners()

      // // Hide Mulberry on PDP - Sep 16, 2024
      // if (document.location.href.search('products/') !== -1) {
      //   if (typeof mulberryShop !== 'undefined') {
      //     mulberryInit()
      //   }
      //   setTimeout(() => {
      //     $(`dl[class="CartItem-properties"]`).text('')
      //   }, 500)
      // }

      if (typeof mulberryShop !== 'undefined') {
        setCartInfoAndRender(true)
      }
      lastURL = window.location.href;
    }
}, 600); 